export { BannerText } from './BannerText';
export { type BannerTextProps } from './BannerText.types';
